// Ubicación en el repo: src/components/DonutChartSVG.jsx
// Dona genérica (SVG puro, sin librería de gráficos) — usada en el
// Dashboard para "Estado de citas del mes" (DECISIONS.md #44 addendum).
// `segments` es [{ label, color, value }]. Mismo criterio que
// TrendChartSVG.jsx: componente de función pura, sin estado propio.
const SIZE = 180;
const STROKE = 26;
const R = (SIZE - STROKE) / 2;
const CIRCUMFERENCE = 2 * Math.PI * R;

export default function DonutChartSVG({ segments, centerLabel }) {
  const total = segments.reduce((sum, s) => sum + s.value, 0);
  let offset = 0;

  return (
    <svg viewBox={`0 0 ${SIZE} ${SIZE}`} width="100%" style={{ maxWidth: 180 }}>
      <g transform={`rotate(-90 ${SIZE / 2} ${SIZE / 2})`}>
        {total === 0 ? (
          <circle cx={SIZE / 2} cy={SIZE / 2} r={R} fill="none" stroke="var(--border)" strokeWidth={STROKE} />
        ) : (
          segments
            .filter((s) => s.value > 0)
            .map((s) => {
              const length = (s.value / total) * CIRCUMFERENCE;
              const dashoffset = -offset;
              offset += length;
              return (
                <circle
                  key={s.label}
                  cx={SIZE / 2}
                  cy={SIZE / 2}
                  r={R}
                  fill="none"
                  stroke={s.color}
                  strokeWidth={STROKE}
                  strokeDasharray={`${length} ${CIRCUMFERENCE - length}`}
                  strokeDashoffset={dashoffset}
                />
              );
            })
        )}
      </g>
      <text x={SIZE / 2} y={SIZE / 2 - 3} textAnchor="middle" fontSize={22} fontWeight={700} fill="var(--primary)">
        {total}
      </text>
      <text x={SIZE / 2} y={SIZE / 2 + 15} textAnchor="middle" fontSize={10.5} fill="#5B6B6E">
        {centerLabel || 'citas'}
      </text>
    </svg>
  );
}
